import { slice, uniqueId } from "lodash";
import React, { useCallback, useContext, useState } from "react";
import { Toast, ToastComponent, ToastOptions } from "../Toast";
import "./style.css";

interface ToastProviderState {
    toasts: Toast[];
}

const ToastContext = React.createContext<any>(null);

const ToastProvider = ({ children }: any) => {
    const [toastProviderState, setToastProviderState] =
        useState<ToastProviderState>({ toasts: [] });

    const addToast = useCallback((content: any, options: ToastOptions) => {
        setToastProviderState((state) => {
            const toasts =
                state.toasts.length === 6
                    ? slice(state.toasts, 1, state.toasts.length)
                    : state.toasts;

            return {
                toasts: [
                    ...toasts,
                    {
                        id: uniqueId(),
                        content: content,
                        options: options,
                    },
                ],
            };
        });
    }, []);

    const removeToast = useCallback((id: string) => {
        setToastProviderState((state) => ({
            toasts: state.toasts.filter((toast: Toast) => toast.id !== id),
        }));
    }, []);

    const removeAllToasts = useCallback(() => {
        setToastProviderState((_) => ({
            toasts: [],
        }));
    }, []);

    return (
        <ToastContext.Provider
            value={{ addToast, removeToast, removeAllToasts }}
        >
            <div className="c-Toast-ToastProvider-container">
                {toastProviderState.toasts.map((toast: Toast) => (
                    <ToastComponent key={toast.id} toast={toast} />
                ))}
            </div>
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    return useContext(ToastContext);
};

export default ToastProvider;
